import EntityTypeEnum from 'common/enums/entityTypeEnum'
import EntityInterface from 'common/types/entities/EntityInterface'
import React from 'react'
import { UpsellButtonEntityInterface } from 'src/shared/entities/upsell-button/upsell-button.schema'
import createCommonEntitySettings from '../createCommonEntitySettings'
import UpsellButtonSettings from './settings/UpsellButtonSettings'

function createSettingsForUpsell(
  entity: EntityInterface,
  defaultEntity?: EntityInterface,
) {
  switch (entity.type) {
    case EntityTypeEnum.UpsellAgreeButton:
    case EntityTypeEnum.UpsellDisagreeButton:
      return (
        <UpsellButtonSettings
          entity={entity as UpsellButtonEntityInterface}
          defaultEntity={defaultEntity as UpsellButtonEntityInterface}
        />
      )
    default:
      return createCommonEntitySettings(entity, defaultEntity)
  }
}

export default createSettingsForUpsell
